import { render, staticRenderFns } from "./_tableTitle.vue?vue&type=template&id=0cd3246c&"
import script from "./_tableTitle.vue?vue&type=script&lang=ts&"
export * from "./_tableTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports